<template>
  <UiCard class="module-card" :style="{ '--delay': delay }">
    <div class="page-header">
      <div class="page-header__left">
        <div>
          <div class="page-header__title">{{ title }}</div>
          <div v-if="showSubtitle" class="page-header__subtitle">{{ subtitle }}</div>
        </div>
      </div>
      <div class="page-header__actions">
        <TeacherClassSwitcher v-if="showTeacherClassSwitcher && !teacherClassSwitcherBeforeBack" />
        <slot />
        <div
          v-if="showTeacherClassSwitcher && teacherClassSwitcherBeforeBack || backClick || backTo || showAdminInlineTools"
          class="page-header__trailing"
          :class="{ 'page-header__trailing--push': teacherClassSwitcherBeforeBack }"
        >
          <TeacherClassSwitcher v-if="showTeacherClassSwitcher && teacherClassSwitcherBeforeBack" />
          <button v-if="backClick" type="button" @click="backClick" class="page-header__back">
            {{ backText }}
          </button>
          <router-link v-else-if="backTo" :to="backTo" class="page-header__back">
            {{ backText }}
          </router-link>
          <AdminInlineTools v-if="showAdminInlineTools" class="page-header__admin-tools" />
        </div>
      </div>
    </div>
  </UiCard>
</template>

<script>
import UiCard from './UiCard.vue'
import TeacherClassSwitcher from '@/components/teacher/TeacherClassSwitcher.vue'
import AdminInlineTools from '@/components/layout/AdminInlineTools.vue'

export default {
  name: 'UiPageHeader',
  components: {
    UiCard,
    TeacherClassSwitcher,
    AdminInlineTools
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    },
    backTo: {
      type: String,
      default: ''
    },
    backClick: {
      type: Function,
      default: null
    },
    backText: {
      type: String,
      default: '返回'
    },
    delay: {
      type: String,
      default: '0s'
    },
    showTeacherClassSwitcher: {
      type: Boolean,
      default: false
    },
    teacherClassSwitcherBeforeBack: {
      type: Boolean,
      default: false
    },
    hideAdminInlineTools: {
      type: Boolean,
      default: false
    },
    forceAdminInlineTools: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    showSubtitle() {
      return Boolean(this.subtitle && this.subtitle.trim()) && !this.$store.getters.isAdmin
    },
    showAdminInlineTools() {
      return !this.hideAdminInlineTools && (this.$store.getters.isAdmin || this.forceAdminInlineTools) && this.$route.path !== '/nav'
    }
  }
}
</script>

<style scoped>
.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: nowrap;
  min-width: 0;
}

.page-header__left {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
  min-width: 0;
}

.page-header__back {
  padding: 6px 12px;
  border-radius: 999px;
  background: rgba(15, 26, 34, 0.08);
  font-size: 12px;
  border: none;
  cursor: pointer;
  text-decoration: none;
  color: var(--brand);
  font-family: inherit;
}

.page-header__title {
  font-family: var(--font-display);
  font-size: 20px;
  letter-spacing: 0.6px;
}

.page-header__subtitle {
  font-size: 12px;
  color: var(--muted);
}

.page-header__actions {
  display: flex;
  flex: 1;
  min-width: 0;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  margin-left: auto;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: none;
}

.page-header__actions::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.page-header__actions > * {
  flex-shrink: 0;
}

.page-header__trailing {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  min-width: 0;
}

.page-header__trailing--push {
  margin-left: auto;
}

.page-header__admin-tools {
  flex: 0 0 420px;
  min-width: 420px;
  margin-left: 8px;
}

@media (max-width: 1280px) {
  .page-header {
    flex-wrap: wrap;
  }

  .page-header__actions {
    flex-wrap: wrap;
    overflow: visible;
  }

  .page-header__admin-tools {
    flex: 1 1 420px;
    min-width: 320px;
  }
}

@media (max-width: 768px) {
  .page-header { flex-direction: column; align-items: stretch; gap: 12px; }
  .page-header__title { font-size: 17px; }
  .page-header__actions { width: 100%; justify-content: flex-start; }
  .page-header__trailing {
    width: 100%;
    flex-wrap: wrap;
    justify-content: flex-start;
  }
  .page-header__trailing--push {
    margin-left: 0;
  }
  .page-header__admin-tools {
    flex-basis: 100%;
    min-width: 0;
    margin-left: 0;
  }
}

@media (max-width: 480px) {
  .page-header__title { font-size: 16px; }
}
</style>
